module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inlineBlock sd-input-munber__range"
  }, [_c('sd-input-number', {
    attrs: {
      "w": "150",
      "name": "min",
      "precision": _vm.precision || 0
    },
    on: {
      "change": _vm.handleMinChange
    },
    model: {
      value: (_vm.min),
      callback: function($$v) {
        _vm.min = $$v
      },
      expression: "min"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mid-lable"
  }, [_vm._v("至")]), _vm._v(" "), _c('sd-input-number', {
    attrs: {
      "w": "150",
      "name": "max",
      "precision": _vm.precision || 0
    },
    on: {
      "change": _vm.handleMaxChange
    },
    model: {
      value: (_vm.max),
      callback: function($$v) {
        _vm.max = $$v
      },
      expression: "max"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1982e6bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SdInputNumberRange.vue
// module id = 714
// module chunks = 20